<template>
	<b-modal centered title="Bienvenido a Kllaar" hide-footer hide-header v-model="modal">
		<div class="row">
			<div class="col-md-12 text-center p-5">
				<img src="@/assets/b_logo.png" height="50">
				<br><br>
				<h4 class="font-blue">¡Bienvenido a Kllaar.com!</h4>
				<div class="font-gray-dark mt-5">
					Ingresa y completa tu <router-link to="/perfil" class="font-orange">Perfil</router-link>
					cuanto antes.<br><br>
					Busca <router-link to="/empleos" class="font-orange">Empleos</router-link>,
					crea tu <router-link to="/perfil/mi-cv" class="font-orange">CV</router-link>,
					encuentra <router-link to="/cursos" class="font-orange">Cursos</router-link>
					<h3 class="font-weight-light my-4">¡Comienza Ya!</h3>
				</div>
				<b-button type="button" @click="onRead" class="b-orange col-md-12">Aceptar</b-button>
			</div>
		</div>
	</b-modal>
</template>
<script>
export default {
	name: 'SuccessStudent',
	data() {
		return {
			modal: true
		}
	},
	methods:{
		onRead(){
			// this.$store.dispatch('activeAccount', true)
			this.modal = false
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/#auth/activation/SuccessStudent.vue